import { Button, Divider, Form, Input } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SenderMail } from './emails/Email';
import {
    useEmailSettingDetail,
    useEmailSettingUpdate,
} from '../hook/useEmailSetting';
import ModalDiscardChanges from '../../../components/Shared/modal/discardChanges';
import usePermission from '../../../hooks/usePermission';

export default function SenderName({ getEmailSettings }) {
    const { t } = useTranslation();
    const [isEditable, setIsEditable] = useState(false);

    const { emailDetail } = useEmailSettingDetail();
    const { updateEmailSetting, loading: loadingSave } =
        useEmailSettingUpdate();

    const [form] = Form.useForm();

    useEffect(() => {
        initForm();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [emailDetail?.subjectEmail]);

    const initForm = () => {
        form.setFieldsValue({
            senderName: emailDetail?.senderName,
            senderEmail: emailDetail?.senderEmail,
        });
    };

    // Discard change
    const [change, setChange] = useState(false);
    const [isOpenDiscard, setIsOpenDiscard] = useState(false);

    const handelOk = async () => {
        setChange(false);
        setIsEditable(false);
        setIsOpenDiscard(false);
        initForm();
    };

    const onCheckIsChange = () => {
        if (change) {
            setIsOpenDiscard(true);
        } else {
            handelOk();
        }
    };

    const onSave = (values) => {
        updateEmailSetting(
            {
                customizeEmailId: emailDetail?.customizeEmailId,
                senderEmail: values.senderEmail,
                senderName: values.senderName,
            },
            () => {
                getEmailSettings();
                setIsEditable(false);
                setChange(false);
            }
        );
    };

    const senderName = Form.useWatch('senderName', form);
    const senderEmail = Form.useWatch('senderEmail', form);

    const { isAuditor, isUser } = usePermission();

    return (
        <Form
            layout="vertical"
            form={form}
            onFieldsChange={(_, allFields) => {
                if (allFields.length > 0) {
                    setChange(true);
                }
            }}
            onFinish={onSave}
        >
            <div className="bg-white rounded-lg p-4">
                <div className="flex items-center justify-between gap-2">
                    <div className="flex items-center gap-2">
                        <div className="font-semibold">Last updated :</div>
                        <div>
                            {emailDetail?.modifyBy || '-'},{' '}
                            {emailDetail?.modifyDate}
                        </div>
                    </div>
                    <div className="flex gap-2">
                        {!isEditable ? (
                            <Button
                                disabled={isAuditor || isUser}
                                onClick={() => setIsEditable(true)}
                                className="w-32"
                                size="large"
                                type="primary"
                                ghost
                            >
                                {t('Edit')}
                            </Button>
                        ) : (
                            <>
                                <Button
                                    onClick={onCheckIsChange}
                                    className="w-32"
                                    size="large"
                                    type="primary"
                                    ghost
                                >
                                    {t('Cancel')}
                                </Button>
                                <Button
                                    className="w-32"
                                    size="large"
                                    type="primary"
                                    htmlType="submit"
                                    loading={loadingSave}
                                >
                                    {t('Save')}
                                </Button>
                            </>
                        )}
                    </div>
                </div>
                <div className="w-max border border-gray-200 rounded-xl p-6 m-auto my-4">
                    <p className="font-semibold">
                        ตั้งชื่อผู้ส่งอีเมล (Sender Name) ให้กับองค์กรของคุณ
                    </p>

                    <div className="grid grid-cols-2 gap-2">
                        <Form.Item
                            name="senderName"
                            label="Sender Name"
                            rules={[
                                {
                                    required: true,
                                    message: t('errorText.requiredField'),
                                },
                            ]}
                        >
                            <Input
                                disabled={!isEditable}
                                size="large"
                                maxLength={50}
                                showCount
                            />
                        </Form.Item>
                        <Form.Item
                            name="senderEmail"
                            label="Sender Email"
                            rules={[
                                {
                                    required: true,
                                    message: t('errorText.requiredField'),
                                },
                                {
                                    type: 'email',
                                    message: t('errorText.emailFormat'),
                                },
                            ]}
                        >
                            <Input
                                disabled={!isEditable}
                                size="large"
                                maxLength={50}
                                showCount
                            />
                        </Form.Item>
                    </div>
                    <div>
                        From :{' '}
                        <span className="text-[#1890FF]">
                            {senderName} {`<${senderEmail}>`}
                        </span>
                    </div>
                    <div>To : ... </div>
                    <Divider />
                    <SenderMail />
                </div>
            </div>
            <ModalDiscardChanges
                open={isOpenDiscard}
                handelOk={handelOk}
                handelClose={() => {
                    setIsOpenDiscard(false);
                }}
            />
        </Form>
    );
}
